










import Vue from "vue";
import DataContainer from "@common/modules/vuetifyx/common/DataContainer";

export default Vue.extend({
  props: ["item"],
  data() {
    const self = this;
    return {
      self,
      updatedItem: null,
      tableContainer: new DataContainer(),
      tableOptions: {
        attrs: {
          "item-key": "connectorId",
          "hide-default-footer": true,
        },
        content: {
          displayFields: {
            type: {
              text: "Type",
              options: {
                label: true,
                attrs: {
                  color: "info",
                  outlined: true,
                },
              },
            },
            startTime: {
              text: "Start Time",
              options: {
                label: true,
                attrs: {
                  color: "primary",
                  outlined: true,
                },
                transform(_, item) {
                  return item.start_time;
                },
              },
            },
            endTime: {
              text: "End Time",
              options: {
                label: true,
                attrs: {
                  color: "info",
                  outlined: true,
                },
                transform(_, item) {
                     return item.end_time;
                },
              },
            },
            price: {
              text: "Price",
              options: {
                transform(_, item) {
                  const {price, type} = item;
                  const unit = type === "ENERGY" ? "kWh" : "session";
                  return `${price}/${unit}`;
                },
              },
            },
            action: {
              text: "Actions",
            },
          },
          template: {
            itemActionButtons: {},
          },
        },
        ext: {
          dataProvider: {
            async findAll() {
              console.log("self.updatedItem", self.updatedItem);
              const items = self.updatedItem.elements || [];
              return [items, items.length];
            },
          },
        },
      },
    };
  },
  created() {
    this.updatedItem = { ...this.item };
  },
});
